export default __webpack_public_path__ + "static/media/IncredibleAnimalsPredators_05.41a152e3.png";